import { createContext } from "react";
import { useEffect, useState, useMemo } from "react";
import { db } from "../firebase/config";
import { doc, getDoc, where, query, getDocs, collection } from 'firebase/firestore';
import { useAuthContext } from "../hooks/useAuthContext";
import { getMaxDemandForWDA } from '../utils/demandUtils';



export function copyToClipboard(jsonObject) {
  if (!jsonObject) {
    return;
  }
  const jsonString = JSON.stringify(jsonObject, null, 2);
  navigator.clipboard.writeText(jsonString)
    .then(() => {})
    .catch(err => {});
}

export function logCipDebugData(jsonObject) {
  if (!jsonObject) {
    return;
  }
  // Debug logging removed for production
}


export const ProductsContext = createContext({
});

export const ProductsProvider = ({children}) => {
    const {user} = useAuthContext()
    const [workforce, setWorkforce] = useState("Empty")
    const [comparisonSelection, setComparisonSelection] = useState("none")
    const [userDefaults, setUserDefaults] = useState({})
    const [filterSession, setFilterSession] = useState("Business & Marketing")
    const [workforceTitle, setWorkforceTitle] = useState([])
    const [currentCip, setCurrentCip] = useState("110201")
    const [navbarSelection, setNavbarSelection] = useState("CIP Report")
    const [stateData, setStateData] = useState(null)
    const [init, setInit] = useState(null)
    const [defaultDistrict, setDefaultDistrict] = useState(null)
    const [cipEquityData, setCipEquityData] = useState(null)
    const [renton, setRenton] = useState(null)
    const [cipDoc, setCipDoc] = useState(null)
    const [collegeData, setCollegeData] = useState(null)
    const [localColleges, setLocalColleges] = useState(null)
    const [jobs, setJobs] = useState(null)
    const [schoolDemo, setSchoolDemo] = useState(null)
    const [workforceMenu, setWorkforceMenu] = useState(null)
    const [viewType, setViewType] = useState("bar")
    const [categories, setCategories] = useState
    ([
      {
      Program:[{title:"Program Area Totals", id:1}],
      Cluster: [{title:"Career Cluster Totals", id:1}]
      }
    ])
    const [stateToggle, setStateToggle] = useState(false)
    const [offeredCip, setOfferedCip] = useState([])
    const [comparisonTest, setComparisonTest] = useState([])
    const [districtName, setDistrictName] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState("Program Area Totals")
    const [selectedSchools, setSelectedSchools] = useState([{value:"loading", label:"loading, please wait"}]);
    const [selectedSchool, setSelectedSchool] = useState({value:"District Total", label:"District Total"});
    const [listSchools, setListSchools] = useState([]);
    const [mainCategory, setMainCategory] = useState("Program");
    const [mainTrendCategory, setMainTrendCategory] = useState("Trend");
    const [selectedOption, setSelectedOption] = useState([]);
    const [selectedFilterLMI, setSelectedFilterLMI] = useState({value:"(All)", label:"(All)"});
    const [selectedFilterIndicatorSchool, setSelectedFilterIndicatorSchool] = useState({value:"District Total", label:"District Total"});
    const [selectedFilterIndicatorGrade, setSelectedFilterIndicatorGrade] = useState({value:"All Grades", label:"All Grades 9-12"});
    const [selectedFilterIndicatorDate, setSelectedFilterIndicatorDate] = useState({value:"2024", label:"2023-24"})
    const [selectedFilterIndicatorDateNew, setSelectedFilterIndicatorDateNew] = useState({value:"2024", label:"2024"})
    const [perkinsSelectedYear, setPerkinsSelectedYEar] = useState({value:"2025", label:"2025"})
    const [selectedDistrictComparison, setSelectedDistrictComparison] = useState ({value:"None", label:"None"})
    const [selectedOptionSpecial, setSelectedOptionSpecial] = useState([]);
    const [selectableDistricts, setSelectableDistricts] = useState(null)
    const nontrad = {female:["110102","110104","010001", "010101", "010102", "010104", "010105", "010201", "010204", "010205", "010301", "010302", "010303", "010306", "010307", "010308", "010309", "010401", "010601", "010602", "010603", "010604", "010605", "010606", "010607", "010802", "010901", "010906", "010907", "011101", "011102", "011103", "011106", "030198", "030301", "030501", "030510", "030511", "090701", "090903", "100201", "100202", "100203", "100305", "110103", "110201", "110204", "110701", "110901", "111003", "111006", "120500", "120501", "120503", "140102", "140501", "141001", "141801", "144201", "150201", "150406", "150505", "150613", "150801", "151201", "151202", "151301", "151302", "151303", "151304", "151305", "151306", "151601", "430100", "430107", "430109", "430116", "430203", "430206", "460000", "460100", "460201", "460302", "470101", "470104", "470201", "470600", "470603", "470604", "470605", "470606", "470607", "470611", "470616", "480503", "480506", "480508", "480511", "480701", "480703", "490102", "490309", "500602", "520201", "521804", "521907"],male:["513902","010504", "120401", "120410", "130101", "131501", "190501", "190504", "190706", "190708", "190710", "220301", "260104", "510601", "510710", "510716", "510801", "510805", "510808", "511199", "511614", "512699", "520302", "520401", "520501"]}
    const [indicatorsCategory, setIndicatorsCategory] = useState({
      value: "Perkins V Indicators",
      label: "Perkins V Indicators",
    });
    const [indicatorsSubcategory, setIndicatorsSubcategory] = useState({
      label: "1S1 - Graduation",
      value: "1S1: Four-Year Graduation Rate",
      category: "Perkins V Indicators",
      database: "perkinsIndicators_2025",
      aggDatabase: "perkinsIndicators_2025",
      title:
        "The percentage of CTE concentrators who graduate high school, as measured by the four-year adjusted cohort graduation rate.",
      subtitle: "CTE concentrators graduated from high school on time.",
      caption: "The percent of students",

    });
    const [performanceComparison, setPerformanceComparison] = useState({value:"State Total",label:"State Total"})
    const [indicatorData, setIndicatorData] = useState(null)
    const [availStudentGroups, setAvailStudentGroups] = useState([])
    const [checkedStudentGroup, setCheckedStudentGroup] = useState(["All Students", "Male", "Female", "Gender X", "White", "Hispanic/ Latino of any race(s)", "Asian", "Two or More Races", "Black/ African American", "American Indian/ Alaskan Native", "Native Hawaiian/ Other Pacific Islander", "Low-Income", "Students with Disabilities", "Homeless"]);
    const [indicatorsAggData, setIndicatorsAggData] = useState(null)
    const [selectableSchools, setSelectableSchools] = useState(["...Loading Schools"])
    const [summaryData, setSummaryData] = useState(null)
    const [open, setOpen] = useState(false)

    const [selectedLaborView, setSelectedLaborView] = useState('table');

    // Chat messages stored per-chat: { [chatId]: messages[] }
    const [chatMessagesMap, setChatMessagesMap] = useState({});
    const [loading,  setLoading ] = useState(false);
    const [artifacts, setArtifacts] = useState({}) // Also per-chat: { [chatId]: artifacts[] }

    // Chat history management
    const [currentChatId, setCurrentChatId] = useState(null);  // The chat being streamed to
    const [visibleChatId, setVisibleChatId] = useState(null);  // The chat being displayed
    const [chats, setChats] = useState([]);
    const [loadingChat, setLoadingChat] = useState(false);

// Get messages for a specific chat
const getMessagesForChat = (chatId) => {
  return chatMessagesMap[chatId] || [];
};

// Set messages for a specific chat
const setMessagesForChat = (chatId, messages) => {
  setChatMessagesMap(prev => ({
    ...prev,
    [chatId]: typeof messages === 'function' ? messages(prev[chatId] || []) : messages
  }));
};

// Get artifacts for a specific chat
const getArtifactsForChat = (chatId) => {
  return artifacts[chatId] || [];
};

// Set artifacts for a specific chat
const setArtifactsForChat = (chatId, newArtifacts) => {
  setArtifacts(prev => ({
    ...prev,
    [chatId]: typeof newArtifacts === 'function' ? newArtifacts(prev[chatId] || []) : newArtifacts
  }));
};

// Legacy compatibility: messages/setMessages that work with visibleChatId
const messages = getMessagesForChat(visibleChatId);
const setMessages = (newMessages) => {
  if (visibleChatId) {
    setMessagesForChat(visibleChatId, newMessages);
  }
};

// Chat management functions
const loadChatMessages = (chatId, chatMessages) => {
  setMessagesForChat(chatId, chatMessages || []);
  setVisibleChatId(chatId);
};

const clearChat = (chatId) => {
  if (chatId) {
    setChatMessagesMap(prev => {
      const next = { ...prev };
      delete next[chatId];
      return next;
    });
    setArtifacts(prev => {
      const next = { ...prev };
      delete next[chatId];
      return next;
    });
  }
  setCurrentChatId(null);
  setVisibleChatId(null);
};

// Clear chat state when user changes (logout/login with different account)
useEffect(() => {
  // Clear chat-related state when user changes
  setChatMessagesMap({});
  setArtifacts({});
  setCurrentChatId(null);
  setVisibleChatId(null);
}, [user?.uid]);

// ...inside your ProductsContext provider
const clearCipData = () => {
  setCurrentCip(null);
  setCipDoc(null);
  setCipEquityData(null);
  // Clear any other CIP-related state here (jobs, collegeData, etc.)
};

const changeCip = (newCipCode) => {
  // Clear current CIP data
  clearCipData();
  
  // Wait for exit animations to complete before loading new data
  setTimeout(() => {
    setCurrentCip(newCipCode);
  }, 200); // 200ms delay (adjust as needed to match your animation duration)
};



    useEffect (() => {
        const fetchDefaults = async () => {
            if(user){
            const docRef = doc (db, 'users', user.uid)
            const docSnap = await getDoc (docRef)
            if (docSnap.exists()){
                // setWorkforce(docSnap.data().defaultWorkforceArea[0])
                setUserDefaults(docSnap.data())
                setDefaultDistrict((Array.isArray(docSnap.data().defaultDistrict)) ? (docSnap.data().defaultDistrict[0]) : (docSnap.data().defaultDistrict))
                setSelectableDistricts((Array.isArray(docSnap.data().defaultDistrict)) ? (docSnap.data().defaultDistrict) : null)
                setWorkforce(docSnap.data().defaultWDA)
                setLocalColleges(docSnap.data().defaultLocalColleges)
            }
        }}
        fetchDefaults()
    }, [user])




    useEffect(() => {
      const initialize = async () => {
          if (defaultDistrict) {
              const docRef = doc(db, 'init_WA_2025-26', defaultDistrict.value);
              const docSnap = await getDoc(docRef);
              if (docSnap.exists()) {
                  const data = docSnap.data();
                  
                  setInit(data);
                  setCategories({
                      Program: (["Program Area Totals", ...new Set(data.cipMenu.map((e) => e.programArea))]).map((e, i) => ({ title: e, id: i })),
                      Cluster: (["Career Cluster Totals", ...new Set(data.cipMenu.map((e) => e.clusterName))]).map((e, i) => ({ title: e, id: i }))
                  });
                  setOfferedCip(data.cipMenu.map((c) => (c.offered && c.cipCode)).filter(Boolean));
                  setSchoolDemo(data.schoolDemo);
                  setRenton(data.cipEnrolled);
                  setDistrictName(data.districtName);
                  setSelectedSchools(data.listSchools.map((e) => ({ value: e, label: e })));
                  setListSchools(data.listSchools);
              }
          }
      };
      initialize();
  }, [user, defaultDistrict]);


  useEffect(() => {
    const initialize = async () => {
      if (defaultDistrict) {
        const docRef = doc(db, 'Summary25_WA', defaultDistrict.value);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSummaryData(docSnap.data());
        } else {
          // explicitly set to null so we don't show stale data
          setSummaryData(null);
          // optionally show an error or console.warn
        }
      }
    };
    initialize();
  }, [user, defaultDistrict]);


    useEffect(() => {

      if(defaultDistrict){
        let ignore = false
        const fetchEquity = async () => {
          try {

            // Get reference
            const equityRef = collection(db, "equityCip_WA_2025GO")

            // Create a query
            const q = query(
              equityRef,
              where('cipcode', '==', currentCip ),where('districtCode', '==', defaultDistrict.value )
            )
            // Execute query
            const querySnap = await getDocs(q)
            const equity = []
            querySnap.forEach((doc) => {
              if (doc.exists())
              {return equity.push(doc.data())}
               return null
            })
            if (!ignore) setCipEquityData(equity)
          } catch (error) {
          }
        }
        fetchEquity()
        return () => { ignore = true }
      }}, [currentCip, defaultDistrict, user])


      useEffect ( () => {
        // Ignore responses for a CIP that is no longer selected
        let ignore = false
        async function getCipCatalog() {
           const ref =  doc(db, 'cipDetails_v181' , currentCip)
           const response = await getDoc(ref)
           if (ignore) return
           if (response.exists()) {
            ((setCipDoc(response.data())))
          }
        else setCipDoc(null)
        }
          getCipCatalog()
          return () => { ignore = true }
       }, [currentCip, user])

       useEffect ( () => {
        let ignore = false
        async function getCollegeData() {
           const ref =  doc(db, 'collegeData' , currentCip)
           const response = await getDoc(ref)
           if (ignore) return
           if (response.exists()) {
            ((setCollegeData(response.data())))
          }
          else setCollegeData(null)
        }
          getCollegeData()
          return () => { ignore = true }
       }, [currentCip, user])



     
useEffect(() => {
  async function getData() {
    const ref = doc(db, "LMI26_WA", workforce);
    const response = await getDoc(ref);

    if (response.exists()) {
      // The raw object from Firestore
      const rawData = response.data(); // e.g. has rawData.socData = [ { onetSOC: ... }, ... ]
      if (Array.isArray(rawData.socData)) {
        // Decorate each job with a 'maxDemand' property
        const updatedSocData = rawData.socData.map((job) => {
          const maxDemand = getMaxDemandForWDA(job.onetSOC, workforce);
          return {
            ...job,
            maxDemand, // 1,2,3, or null
          };
        });

        // Now store it in state with the updated array
        setJobs({
          ...rawData,
          socData: updatedSocData,
        });
      } else {
        // If there's no socData array
        setJobs(rawData);
      }
    } else {
      setJobs(null);
    }
  }

  getData();
}, [user, workforce]);


useEffect(() => {
  const fetchWorkforceMenu = async () => {
    try {
      const module = await import('../data/workforceMenuItem.json');
      // Depending on your bundler configuration, the JSON may be under `default`
      setWorkforceMenu(module.default || module);
    } catch (error) {
      // Error loading workforce menu
    }
  };

  fetchWorkforceMenu();
}, [user]);


        useEffect (() => {
          const fetchStateData = async () => {
              const docRef = doc (db, 'statewide_2025', "Statewide")
              const docSnap = await getDoc (docRef)
              if (docSnap.exists()){
                  setStateData(docSnap.data().cipEnrolled)
          }}
          fetchStateData()
      }, [user])



      useEffect(() => {
        const fetchComparison = async () => {
          try {
            // Get reference
            const comparisonRef = collection (db, "comparison_2024")

            // Create a query
            const q = query(
              comparisonRef,
             where('districtName', '==', comparisonSelection )
            )
            // Execute query
            const querySnap = await getDocs(q)
            const comparison = []
            querySnap.forEach((doc) => {
              if (doc.exists())
              {return comparison.push(doc.data().enrolled)}
               return null
            })
            setComparisonTest(comparison)
          } catch (error) {
          }
        }
        fetchComparison()
      }, [comparisonSelection, user])


const [isOpen, setIsOpen] = useState(false);
// useEffect(() => {
// }, [isOpen]);

      // advancedFilters, histogramParams, etc. from your code:
  const defaultAdvancedFilters = {
    education: [],
    salaryRange: [0, 999999],
    openingsRange: [0, 5],
    growthRange: [0, 99],
    hasCipOffered: false,
    isStem: false,
    
  };
  const [advancedFilters, setAdvancedFilters] = useState(defaultAdvancedFilters);

  const defaultHistogramParams = {
    salaryBinSize: 10000,
  };
  const [histogramParams, setHistogramParams] = useState(defaultHistogramParams);


  // -----------------------------------------
  //  Compute overall global min/max for Salary
  //  ignoring all filters, so the user can keep
  //  a stable slider range. We do this once per workforce.
  // -----------------------------------------
  const [originalSalaryRange, setOriginalSalaryRange] = useState([0, 999999]);

  useEffect(() => {
    if (!jobs?.socData?.length) {
      setOriginalSalaryRange([0, 999999]);
      return;
    }
    // Extract all non-null wages
    const allWages = jobs.socData
      .map((job) => job.avgAnnualWage)
      .filter((val) => val != null);
    // Check if any job has a null wage
    const hasNullWage = jobs.socData.some((job) => job.avgAnnualWage == null);
    
    if (!allWages.length) {
      setOriginalSalaryRange([0, 999999]);
      return;
    }
    const min = Math.min(...allWages);
    const max = Math.max(...allWages);
    const binSize = histogramParams.salaryBinSize;
    // If any job has a null wage, force the minimum to 0.
    const minRounded = hasNullWage ? 0 : Math.floor(min / binSize) * binSize;
    const maxRounded = Math.ceil(max / binSize) * binSize;
    const computedRange = [minRounded, maxRounded];
  
    setOriginalSalaryRange(computedRange);
  
    // Update advancedFilters if they still hold the raw defaults,
    // so that on initial load they match the computed range (preventing filter pills).
    setAdvancedFilters((prev) => {
      if (prev.salaryRange[0] === 0 && prev.salaryRange[1] === 999999) {
        return { ...prev, salaryRange: computedRange };
      }
      return prev;
    });
  }, [jobs, histogramParams.salaryBinSize, workforce, setAdvancedFilters]);

  
  // excluding a specific field (e.g., 'salaryRange', 'openingsRange', or 'growthRange')
  const meetsOtherFilters = (job, filters, excludeField) => {
    // Education filter
    if (filters.education.length > 0 && !filters.education.includes(job.education)) {
      return false;
    }
    // Salary range filter (if not excluded)
    if (excludeField !== 'salaryRange') {
      const wage = job.avgAnnualWage || 0;
      if (wage < filters.salaryRange[0] || wage > filters.salaryRange[1]) {
        return false;
      }
    }
    // Openings range filter (if not excluded)
    if (excludeField !== 'openingsRange') {
      const openings = job.avgTotalOpenings || 0;
      if (openings < filters.openingsRange[0] || openings > filters.openingsRange[1]) {
        return false;
      }
    }
    // Growth range filter (if not excluded)
    if (excludeField !== 'growthRange') {
      const growth = job.longtermGrowth || 0;
      if (growth < filters.growthRange[0] || growth > filters.growthRange[1]) {
        return false;
      }
    }
    // CIP offered filter
    if (filters.hasCipOffered) {
      if (!job.alignedCip || job.alignedCip.length === 0) {
        return false;
      }
    }
    // STEM filter
    if (filters.isStem) {
      if (!job.isSTEM) {
        return false;
      }
    }
    return true;
  };


const globalSalaryData = useMemo(() => {
  if (!jobs?.socData) return [];
  // Filter the advancedFilters minus the salaryRange constraint:
  return jobs.socData.filter(job => meetsOtherFilters(job, advancedFilters, 'salaryRange'));
}, [jobs, advancedFilters]);

/* ---------- Category Mappings for Program ↔ Cluster auto-matching ---------- */
const categoryMappings = useMemo(() => {
  if (!init?.cipMenu) return { programToCluster: {}, clusterToProgram: {} };

  const programToCluster = {};
  const clusterToProgram = {};

  init.cipMenu.forEach(cip => {
    const program = cip.programArea;
    const cluster = cip.clusterName;
    if (program && cluster) {
      // Map program to most common cluster
      if (!programToCluster[program]) programToCluster[program] = {};
      programToCluster[program][cluster] = (programToCluster[program][cluster] || 0) + 1;

      // Map cluster to most common program
      if (!clusterToProgram[cluster]) clusterToProgram[cluster] = {};
      clusterToProgram[cluster][program] = (clusterToProgram[cluster][program] || 0) + 1;
    }
  });

  // Convert counts to best match
  const getBestMatch = (obj) => {
    const result = {};
    Object.entries(obj).forEach(([key, counts]) => {
      result[key] = Object.entries(counts).sort((a, b) => b[1] - a[1])[0]?.[0];
    });
    return result;
  };

  return {
    programToCluster: getBestMatch(programToCluster),
    clusterToProgram: getBestMatch(clusterToProgram)
  };
}, [init?.cipMenu]);

/* ---------- Set default filterSession when categories load ---------- */
useEffect(() => {
  // Check the appropriate category list based on current view
  const currentCategories = mainCategory === "Cluster" ? categories.Cluster : categories.Program;
  const totalsTitle = mainCategory === "Cluster" ? "Career Cluster Totals" : "Program Area Totals";

  if (currentCategories?.length > 1) {
    const titles = currentCategories.map(c => c.title);
    // Allow "Totals" as a valid deselected state - don't force a selection
    const isValidSelection = titles.includes(filterSession) ||
                             filterSession === totalsTitle ||
                             filterSession.startsWith('nontrad-');

    // Only auto-select if filterSession is truly invalid (e.g., switching districts)
    if (!isValidSelection) {
      const first = currentCategories.find(c => c.title !== totalsTitle);
      if (first) setFilterSession(first.title);
    }
  }
}, [categories, filterSession, mainCategory]);

/* ---------- 1. Clean user profile ---------- */
const userProfile = useMemo(() => {
  if (!userDefaults) return null;
  
  return {
    userName            : `${userDefaults.firstName ?? ""} ${userDefaults.lastName ?? ""}`.trim(),
    jobTitle            : userDefaults.jobTitle ?? null,
    defaultZip          : userDefaults.defaultZip ?? null,
    defaultWDA          : userDefaults.defaultWDA ?? null,
    defaultConsortium   : userDefaults.defaultConsortium ?? [],
    defaultLocalColleges: userDefaults.defaultLocalColleges ?? [],
    
    // District information from init object instead of userDefaults
    districtCode        : init?.districtCode ?? null,
    districtName        : init?.districtName ?? null,
    districtNameShort   : init?.districtNameShort ?? null,
    
    // School information from the init object
    schoolDemo          : schoolDemo ?? null,
    schoolNames         : listSchools ?? []
  };
}, [userDefaults, init, schoolDemo, listSchools]);

/* ---------- 2. Assistant-ready context ---------- */
const assistantContext = useMemo(() => {
  // Wait for critical data
  if (!userProfile) return null;

  return {
    userProfile: {
      ...userProfile,
      // Explicitly add the district code from defaultDistrict
      districtCode: defaultDistrict?.value || null,
    },
    
    // Add enrollment data for current CIP if available
    currentCipData: renton ? renton.find(c => c.cipcode === currentCip) : null,
    
    // Include district information
    district: {
      code: defaultDistrict?.value || null,
      name: districtName || (defaultDistrict?.label || null)
    },
    
    // Include current CIP information
    cipInfo: cipDoc ? {
      code: currentCip,
      details: cipDoc.cipDetails || null
    } : null,
    
    // Include equity data if available
    equityData: cipEquityData || null,
    
    // Available CIP codes
    availableCIPs: offeredCip || []
  };
}, [
  userProfile, 
  currentCip, 
  renton, 
  districtName, 
  defaultDistrict, 
  cipDoc, 
  cipEquityData, 
  offeredCip
]);



            const value = {
              artifacts, setArtifacts, loading, setLoading, messages, setMessages,
              currentChatId, setCurrentChatId, visibleChatId, setVisibleChatId,
              chats, setChats, loadingChat, setLoadingChat,
              loadChatMessages, clearChat,
              getMessagesForChat, setMessagesForChat,
              getArtifactsForChat, setArtifactsForChat,
              userProfile, assistantContext, categoryMappings, perkinsSelectedYear, setPerkinsSelectedYEar, viewType, setViewType,selectedLaborView, setSelectedLaborView, isOpen, setIsOpen, advancedFilters,originalSalaryRange,globalSalaryData,
    setAdvancedFilters,
    jobs,
    histogramParams,
    setHistogramParams,changeCip,clearCipData, open, setOpen, summaryData, nontrad, selectedFilterIndicatorDateNew, setSelectedFilterIndicatorDateNew, selectedFilterIndicatorGrade, setSelectedFilterIndicatorGrade, selectedOption, setSelectedOption, selectedOptionSpecial, setSelectedOptionSpecial, selectedFilterLMI, setSelectedFilterLMI, selectableDistricts, setSelectableDistricts, setDefaultDistrict,
              schoolDemo, defaultDistrict,mainTrendCategory, setMainTrendCategory, mainCategory, setMainCategory, selectedCategory, setSelectedCategory, listSchools, localColleges, selectedSchool, setSelectedSchool, selectedSchools, setSelectedSchools, districtName, comparisonTest, setComparisonSelection, comparisonSelection, stateData, renton, setCurrentCip, currentCip, workforce, setWorkforce, userDefaults, setUserDefaults, filterSession, setFilterSession, workforceTitle, setWorkforceTitle, init, workforceMenu, cipEquityData, cipDoc, collegeData, categories, offeredCip, user,
              selectedFilterIndicatorSchool,setSelectedFilterIndicatorSchool,indicatorsCategory, setIndicatorsCategory,indicatorsSubcategory, setIndicatorsSubcategory, navbarSelection, setNavbarSelection, stateToggle, setStateToggle, performanceComparison, setPerformanceComparison,
              indicatorData, setIndicatorData, availStudentGroups, setAvailStudentGroups,checkedStudentGroup, setCheckedStudentGroup,
              indicatorsAggData, setIndicatorsAggData, selectedDistrictComparison, setSelectedDistrictComparison, selectableSchools, setSelectableSchools,
              selectedFilterIndicatorDate, setSelectedFilterIndicatorDate
            };

    return (
        <ProductsContext.Provider value={value}> {children} </ProductsContext.Provider>
    )
}